// extracted by mini-css-extract-plugin
export var completionBody = "_lu-2";
export var completionCard = "_lu-0";
export var completionFooter = "_lu-3";
export var completionTitle = "_lu-1";